import { Button } from "@pushpress/shared-components";
import { useCalendar } from "../../CalendarProvider/CalendarProvider";
import { useState } from "react";
import { toast } from "react-toastify";
import { defaultToastOptions, extractError } from "../../../../utils/misc";

interface CheckinButtonProps {
  registrationUuid: string;
  hide?: boolean;
  onSuccess?: VoidFunction;
}

const source = "Core - class view";

const CheckinButton = (props: CheckinButtonProps) => {
  const { registrationUuid, hide, onSuccess } = props;

  const { checkIn } = useCalendar();

  const [loading, setLoading] = useState(false);

  const handleCheckin = async () => {
    setLoading(true);
    try {
      await checkIn({
        checkinInput: {
          reservationId: registrationUuid,
          overrideRules: true,
          source,
        },
      });
      onSuccess?.();
    } catch (error) {
      toast.error(extractError(error), defaultToastOptions);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      text="Check in"
      loading={loading}
      buttonType="secondary"
      style={{ visibility: hide ? "hidden" : undefined }}
      onClick={handleCheckin}
    />
  );
};

export default CheckinButton;
